<script>
    import Error404 from "../../placeholders/Error404.svelte";
    window.scrollTo(0, 0);
</script>

<section class="error-page">
    <div class="row">
        <div class="col-12">
            <Error404/>
        </div>
    </div>
</section>


<style>

</style>